import { ExpandMore, Edit } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Theme, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { formatMoney } from '../../../helpers';
import { getColorSchemes } from '../../../fetch/color-schemes';
import { ExcludedColorOptions } from '../manage-neighborhoods/options/excluded-options-colors/excluded-color-options';
interface IColorSchemeAccordion {
  colorSchemeItem: any;
  isAllAccordionsExpanded?: boolean;
  refetchData?: () => void;
}
export const ColorSchemeAccordion: FC<IColorSchemeAccordion> = ({
  colorSchemeItem,
  isAllAccordionsExpanded
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [isExpanded, setExpanded] = useState<boolean>(isAllAccordionsExpanded ?? false);

  const { isLoading: isLoadingColorSchemeUris, data: colorSchemeUris } = useQuery<any, Error>(
    ['getColorSchemes', colorSchemeItem],
    () => getColorSchemes(colorSchemeItem?.colorSchemeId)
  );

  useEffect(() => {
    setExpanded(isAllAccordionsExpanded);
  }, [isAllAccordionsExpanded]);

  return (
    <>
      <Accordion
        expanded={isExpanded}
        onChange={(_, expanded) => {
          setExpanded(expanded);
        }}
        className={classes.root}
      >
        <AccordionSummary
          className={classes.accordion}
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.topPanelSummaryWrapper}>
            <div className={classes.boldName}>
              <span className={classes.panelItem}>{colorSchemeItem?.code}</span>
              <span className={classes.panelItem}>{formatMoney(colorSchemeItem?.upgradeFee)}</span>
              <span className={classes.panelItem}>
                {colorSchemeItem?.isActive === false ? 'Inactive' : 'Active'}
              </span>
            </div>
            <div className={classes.buttonsWrapper}>
              <IconButton
                color="primary"
                aria-label="Edit Series"
                size="large"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  history.push(
                    `/development/color-schemes/${colorSchemeItem?.colorSchemeId}/general-information`
                  );
                }}
              >
                <Edit />
              </IconButton>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <ExcludedColorOptions
            colorUris={colorSchemeUris}
            isLoadingColorExclusionOptions={isLoadingColorSchemeUris}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
};
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 },
    [theme.breakpoints.down('sm')]: {
      width: '50vw'
    }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    width: '100%'
  },
  buttonsWrapper: {
    display: 'flex',
    marginRight: theme.spacing(1)
  },
  boldName: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '100px 150px 100px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '50px 75px 75px'
    }
  },
  panelItem: {
    flex: 1
  }
}));
